import { DateTime } from "luxon";

export class DateHelper
{
    public static null(): DateTime
    {
        return DateTime.invalid("null")
    }

    public static fromLocaleDateString(text: string): DateTime
    {
        return DateTime.fromFormat(text, DateTime.parseFormatForOpts(DateTime.DATE_SHORT) ?? "");
    }

    public static fromLocaleTimeString(text: string): DateTime
    {
        return DateTime.fromFormat(text, DateTime.parseFormatForOpts(DateTime.TIME_SIMPLE) ?? "");
    }

    public static fromLocaleDateTimeString(text: string): DateTime
    {
        return DateTime.fromFormat(text, DateTime.parseFormatForOpts(DateTime.DATETIME_SHORT) ?? "");
    }

    public static fromUrl(value: string): DateTime
    {
        let dateTime = DateTime.fromFormat(value, 'yyyy-MM-dd_HH-mm-ss');
        if (!dateTime.isValid)
        {
            dateTime = DateTime.fromFormat(value, 'yyyy-MM-dd');
        }
        if (!dateTime.isValid)
        {
            return DateHelper.null();
        }
        return dateTime;
    }
}



